import React from "react";
import { InlineMath, BlockMath } from "react-katex";
import FractionInput from "../../../../components/inputs/FractionInput";

// ==== GENERATOR ====

export function generateTask() {
  const n = Math.floor(Math.random() * 7) + 3;         // n ∈ [3,9]
  const a1 = Math.floor(Math.random() * 10) + 1;      // a1 ∈ [1,10]
  const r = Math.floor(Math.random() * 5) + 1;        // r ∈ [1,5]

  const Sn = (n / 2) * (2 * a1 + (n - 1) * r);

  return {
    type: "FindRFromSumTask",
    data: { n, a1, Sn, r }
  };
}

// ==== RENDER ====

export function renderTask({ data }) {
  const { n, a1, Sn } = data;

  return (
    <>
      <p>
        Dany jest ciąg arytmetyczny o pierwszym wyrazie{" "}
        <InlineMath math={`a_1 = ${a1}`} />.
      </p>
      <p>
        Suma pierwszych <InlineMath math={`n = ${n}`} /> wyrazów wynosi{" "}
        <InlineMath math={`S_n = ${Sn}`} />. Wyznacz <InlineMath math="r" />.
      </p>
    </>
  );
}

export function renderInput(_, userAnswer, onChange, disabled) {
  return (
    <FractionInput
      value={userAnswer}
      onChange={onChange}
      disabled={disabled}
    />
  );
}

export function checkAnswer({ data }, userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object") return false;
  const given = parseFloat(userAnswer.raw);
  if (isNaN(given)) return false;

  return Math.abs(given - data.r) < 0.01;
}

export function renderAnswer({ data }) {
  return (
    <InlineMath math={`r = ${data.r}`} />
  );
}

export function renderExplanation({ data }) {
  const { n, a1, Sn, r } = data;

  const left = (2 * Sn) / n;
  const twoA1 = 2 * a1;
  const numerator = left - twoA1;
  const denominator = n - 1;
  const result = r;

  return (
    <div className="space-y-2">
      <p>
        <strong>Krok 1:</strong> Wzór na sumę <InlineMath math="n" /> wyrazów ciągu arytmetycznego:
      </p>
      <BlockMath math={`S_n = \\frac{n}{2} \\big( 2a_1 + (n-1)r \\big)`} />

      <p>
        <strong>Krok 2:</strong> Podstawiamy dane i rozwiązujemy względem <InlineMath math="r" />:
      </p>
      <BlockMath
        math={`${Sn} = \\frac{${n}}{2} \\big( 2 \\cdot ${a1} + (${n}-1) \\cdot r \\big)`}
      />
      <BlockMath
        math={`\\frac{2 \\cdot ${Sn}}{${n}} = 2 \\cdot ${a1} + (${n}-1) \\cdot r`}
      />
      <BlockMath
        math={`${left} - ${twoA1} = (${denominator}) \\cdot r`}
      />
      <BlockMath
        math={`\\frac{${numerator}}{${denominator}} = r`}
      />
      <BlockMath
        math={`r = ${result}`}
      />
    </div>
  );
}

export function renderUserAnswer(userAnswer) {
  if (!userAnswer || typeof userAnswer !== "object" || !userAnswer.raw) {
    return <i>(brak odpowiedzi)</i>;
  }

  return <InlineMath math={`r = ${userAnswer.raw}`} />;
}
